module.exports = __webpack_public_path__ + "img/sand-dune-decal-04.27018cbd.png";